import { S as Swiper, N as Navigation, c, e } from "./navigation.chunk.js";
import { M as Manipulation } from "./manipulation-swiper.js";
import { P as Pagination, T as Thumb } from "./thumbs.chunk.js";

class jollyQuantitySelector extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });
    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.querySelectorAll("button").forEach((button) => button.addEventListener("click", this.onButtonClick.bind(this)));
    this.checkInputValue(this.input.value);
  }
  checkInputValue(val) {
    const buttonMinus = this.querySelector(".quantity__button[name='minus']");
    if (val == 1) {
      buttonMinus.classList.add("disabled");
    }
  }
  onInputChange(event) {
    this.validateQtyRules();
    //if(document.querySelector('upsell-variant-picker') != null) document.querySelector('upsell-variant-picker').updateMainWidgetPrices(parseInt(event.target.value,10));
  }
  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    clickOnCheckedOption();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle("disabled", value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle("disabled", value >= max);
    }
    clickOnCheckedOption();
  }
}
customElements.define("jolly-quantity-selector", jollyQuantitySelector);

const atcWrapper = document.querySelector("#buy-button-block");
const atcWrapperBundle = document.querySelector("#buy-button-block-bundle");
const stickyAtcWrapper = document.querySelector(".js-sticky-atc");

let options = {
  rootMargin: "0px",
};

const callbackAtcBtn = (entries, observer) => {
  entries.forEach((entrie) => {
    if (entrie.isIntersecting) {
      stickyAtcWrapper.classList.add("jc-opacity-0", "jc-invisible");
      document.body.style.paddingBottom = "0";
    } else {
      stickyAtcWrapper.classList.remove("jc-opacity-0", "jc-invisible");
      document.body.style.paddingBottom = stickyAtcWrapper.scrollHeight + "px";
    }
  });
};

const observerBtnAtc = new IntersectionObserver(callbackAtcBtn, options);

if (atcWrapper !== null) {
  observerBtnAtc.observe(atcWrapper);
}

if (atcWrapperBundle !== null) {
  observerBtnAtc.observe(atcWrapperBundle);
}

const productFormAtc = document.querySelector('product-form button[name="add"]');
if (productFormAtc) {
  observerBtnAtc.observe(productFormAtc);
}

const mainSwiper = document.querySelector("#productMainSlider");
const slides = mainSwiper.querySelectorAll("div.swiper-slide");
const thumbsSwiper = document.querySelector("#productMainSliderThumbs");
const thumbsMobileSwiper = document.querySelector("#productMainSliderThumbsMobile");
const thumbs = thumbsSwiper.querySelectorAll("div.swiper-slide");
const thumbsMobile = thumbsMobileSwiper.querySelectorAll("div.swiper-slide");
const thumbCount = parseInt(thumbsSwiper.dataset.thumbCount);

const defaultOptions = mainSwiper.dataset.options.split("-");
const defaultImageId = mainSwiper?.hasAttribute('data-image-id') ? mainSwiper.dataset.imageId : null;

let productMainSliderThumbNails = new Swiper("#productMainSliderThumbs", {
  modules: [Manipulation],
  direction: "vertical",
  spaceBetween: 16,
  slidesPerView: thumbCount,
  watchSlidesProgress: true,
  on: {
    init: function () {
      thumbsSwiper.style.display = "block";
    },
  },
});
if (productMainSliderThumbNails.initialized) {
  thumbsSwiper.style.display = "block";
} else {
  thumbsSwiper.style.display = "none";
}

let productMainSliderThumbNailsMobile = new Swiper("#productMainSliderThumbsMobile", {
  modules: [Manipulation],
  direction: "horizontal",
  slidesPerView: thumbsMobile.length > 3 ? 4.75 : 'auto',
  spaceBetween: 4,
  slidesOffsetBefore: 18,
  slidesOffsetAfter: thumbsMobile.length > 3 ? 18 : 0,
  watchSlidesProgress: true,
  on: {
    init: function () {
      thumbsMobileSwiper.style.display = "block";
    },
    update: function () {
      productMainSliderThumbNailsMobile.slides.length < 5 ? thumbsMobileSwiper.classList.add('thumbs-static') : thumbsMobileSwiper.classList.remove('thumbs-static');
    },
  },
});
if (productMainSliderThumbNailsMobile.initialized) {
  thumbsMobileSwiper.style.display = "block";
} else {
  thumbsMobileSwiper.style.display = "none";
}

let productMainSlider = new Swiper("#productMainSlider", {
  modules: [Navigation, Manipulation, Pagination, Thumb],
  loop: true,
  speed: 500,
  navigation: {
    nextEl: ".swiper-button-next.productMainSlider-swiper-button-next",
    prevEl: ".swiper-button-prev.productMainSlider-swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination.productMainSlider-swiper-pagination",
    clickable: true,
  },
  thumbs: {
    swiper: window.innerWidth > 768 ? productMainSliderThumbNails : productMainSliderThumbNailsMobile,
  },
});

document.addEventListener("DOMContentLoaded", function () {
  updateCarousel(defaultOptions, defaultImageId);
});

function addStickyClass() {
  let initialHeaderHeight = 0;
  const currentAnnouncementBarHeight = document.querySelector("#announcementBarSwiper").offsetHeight;
  const currentHeaderHeight = document.querySelector("header").offsetHeight;
  const indentFromTop = currentAnnouncementBarHeight + currentHeaderHeight;
  const mainContent = document.querySelector(".js-sticky-swiper");
  if (initialHeaderHeight !== indentFromTop) {
    mainContent.style.top = indentFromTop + "px";
    initialHeaderHeight = indentFromTop;
  }
}

addStickyClass();
window.addEventListener("resize", addStickyClass);
const currentCurrency = document.querySelector(".js-main-product").dataset.currentCurrency;
function subscriptionLoaded() {
  const subscriptionLoadingElements = document.querySelectorAll("[data-subscription-loading]");
  const loadingIcons = document.querySelectorAll(".jc-loading-icon");
  subscriptionLoadingElements.forEach((el) => {
    el.classList.add("jc-loaded");
  });
  loadingIcons.forEach((icon) => {
    icon.style.display = "none";
  });
}
const subscriptionSystemEnabled = document.querySelector(".jc-subscripiton-system");
!subscriptionSystemEnabled ? subscriptionLoaded() : null;
class VariantChange extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      variants: this.querySelectorAll(".js-variants-update"),
      variantsJSON: this.querySelector("[data-product-variants-json]"),
      productMetafieldsImageJSON: this.querySelector("[data-product-metafields-image-json]"),
      sectionId: "ajax-jolly-main-product-info",
      // Alternative call to the original section of product
      // sectionId: this.dataset.sectionId
    };
    this.init();
  }

  connectedCallback() {
    document.dispatchEvent(new Event("variantChangeInitialized"));
  }

  disconnectedCallback() {
    this.cleanup();
  }

  async updateProductInfo(productHandle, currentVariantId, sectionId, preorder) {
    try {
      const response = await fetch(`${window.Shopify.routes.root}products/${productHandle}?variant=${currentVariantId}&section_id=${sectionId}`);
      if (!response.ok) throw new Error(`Failed to fetch product: ${response.statusText}`);
      const data = await response.text();
      const parser = new DOMParser();
      const parsedData = parser.parseFromString(data, "text/html");
      this.updateElements(parsedData);
      this.updateStickyVariantLabels();
      clickOnCheckedOption();
      if (preorder !== null) this.updateATCPreorder(preorder);
    } catch (error) {
      console.error(`An error occurred: ${error}`);
    }
    document.body.dispatchEvent(new Event("variantUpdateElements"));
  }
  // Update various elements with new content
  updateElements(parsedData) {
    var _a, _b, _c, _d;
    const oldVariantsBlock = document.querySelector(".jolly--variant_selectors");
    const newVariantsHtml = (_a = parsedData.querySelector(".jolly--variant_selectors")) == null ? void 0 : _a.innerHTML;
    const oldBuyButtonBlock = document.querySelector("#buy-button-block");
    const newBuyButtonHtml = (_b = parsedData.querySelector("#buy-button-block")) == null ? void 0 : _b.innerHTML;
    const oldStickyBuyButtonBlock = document.querySelector("#js-main-product-sticky-atc");
    const newStickyBuyButtonHtml = (_c = parsedData.querySelector("#js-main-product-sticky-atc")) == null ? void 0 : _c.innerHTML;
    const oldStickyVariantsBlock = document.querySelector(".jolly-sticky-atc--variant_selectors");
    const newStickyVariantsHtml = (_d = parsedData.querySelector(".jolly-sticky-atc--variant_selectors")) == null ? void 0 : _d.innerHTML;
    oldVariantsBlock ? (oldVariantsBlock.innerHTML = newVariantsHtml) : null;
    oldBuyButtonBlock ? (oldBuyButtonBlock.innerHTML = newBuyButtonHtml) : null;
    oldStickyBuyButtonBlock ? (oldStickyBuyButtonBlock.innerHTML = newStickyBuyButtonHtml) : null;
    oldStickyVariantsBlock ? (oldStickyVariantsBlock.innerHTML = newStickyVariantsHtml) : null;
    const enableSubscriptionSystem = document.querySelector(".rc-container-wrapper");
    if (enableSubscriptionSystem) {
      handlePricesAndDiscounts();
      clickOnCheckedOption();
    }
  }
  // Update sticky variant labels based on checked inputs
  updateStickyVariantLabels() {
    const checkedInputs = this.querySelectorAll(".js-variants-update:checked");
    const checkedOptionIds = Array.from(checkedInputs, (input) => input.id);
    const stickyVariantLabels = document.querySelectorAll(".jc-sticky-variant-label");
    stickyVariantLabels.forEach((label) => {
      if (checkedOptionIds.includes(label.htmlFor)) {
        label.setAttribute("data-checked", "");
      } else {
        label.removeAttribute("data-checked");
      }
    });
  }

  updateDateDelivery(data) {
    const element = document.querySelector(".jc-delivery-fill-please");
    if (!element) return;
    const content = element.querySelector(".jc-delivery-date--text");
    const boutonModal = document.querySelector('button[data-modal="#modal_preorder"]');

    if (data) {
      if (content) {
        const clonedBoutonModal = boutonModal.cloneNode(true);
        const modal = document.querySelector("#modal_preorder");
        modal.querySelector(".jc-richtext").innerHTML = data.popup_content.replace(/\n/g, "<br>");
        element.classList.add("preorder");
        content.textContent = data.precision;
        clonedBoutonModal.classList.remove("hidden");
        if (element.querySelector("button")) {
          element.removeChild(element.querySelector("button"));
        }
        element.appendChild(clonedBoutonModal);
      } else {
        setTimeout(() => {
          this.updateDateDelivery(data);
        }, 100);
      }
    } else {
      element.classList.remove("preorder");
      element.innerHTML = document.querySelector(".delivery-date-snippet").innerHTML;
      element.classList.remove("hidden");
    }
  }

  updateATCPreorder(preorder) {
    var buttons = document.querySelectorAll("button[js-add-to-cart-btn]");
    if (preorder) {
      buttons.forEach((button) => {
        button.querySelector("#mainText").classList.add("hidden");
        button.querySelector("#altText").classList.remove("hidden");
      });
    } else {
      buttons.forEach((button) => {
        button.querySelector("#mainText").classList.remove("hidden");
        button.querySelector("#altText").classList.add("hidden");
      });
    }
  }

  init() {
    this.elements.variants.forEach((element) => {
      element.addEventListener("click", async () => {
        var _a;
        const parsedVariantsJSON = JSON.parse(this.elements.variantsJSON.textContent);
        const checkedInputs = this.querySelectorAll(".js-variants-update:checked");
        const checkedOption = Array.from(checkedInputs, (input) => input.value);
        const currentVariant = parsedVariantsJSON.find((variant) => variant.options.join(",") === checkedOption.join(","));
        let currentVariantImageId = (_a = currentVariant == null ? void 0 : currentVariant.featured_image) == null ? void 0 : _a.id;
        if (this.elements.productMetafieldsImageJSON) {
          const parsedMetafieldsImageJSON = JSON.parse(this.elements.productMetafieldsImageJSON.textContent);
          if (parsedMetafieldsImageJSON && parsedMetafieldsImageJSON[0]?.image) {
            const firstImageId = parsedMetafieldsImageJSON[0].image.split('/').pop();
            if (firstImageId) {
              currentVariantImageId = firstImageId;
            }
          }
        }

        if (checkedOption) {
          updateCarousel(checkedOption, currentVariantImageId)
        } else {
          if (currentVariantImageId) {
            const currentSlideIndex = document.querySelector(`[data-product-image-id^="${currentVariantImageId}"]`).dataset.slideIndex;
            productMainSlider.slideToLoop(currentSlideIndex, 500);
            document.querySelectorAll("[data-sticky-product-image-id]").forEach((image) => {
              image.classList.remove("jc-opacity-100");
              image.classList.add("jc-opacity-0");
            });
            document.querySelector(`[data-sticky-product-image-id^="${currentVariantImageId}"]`).classList.add("jc-opacity-100");
          }
        }

        const productHandle = this.dataset.productHandle;
        const currentVariantId = currentVariant.id;
        const sectionId = this.elements.sectionId;

        var preorder = null;
        const upsellVariantContainerElement = document.querySelector("#injectUpsellVariantPickerHere");
        preorder = upsellVariantContainerElement ? null : currentVariant.metafields && currentVariant.metafields.active ? true : false;

        document.dispatchEvent(
          new CustomEvent("variant:change", {
            detail: {
              variant: currentVariant,
              preorder: preorder,
            },
          })
        );

        await this.updateProductInfo(productHandle, currentVariantId, sectionId, preorder);
      });

    });

    this.handleVariantDataChanged = this.handleVariantDataChanged.bind(this);
    document.addEventListener("variantDataChanged", this.handleVariantDataChanged);
  }

  handleVariantDataChanged() {
    const upsellVariantContainerElement = document.querySelector("#injectUpsellVariantPickerHere");
    if (upsellVariantContainerElement) {
      document.dispatchEvent(new Event("upsellVariantChange"));
    } else {
      const parsedVariantsJSON = JSON.parse(this.elements.variantsJSON.textContent);
      const checkedInputs = this.querySelectorAll(".js-variants-update:checked");
      const checkedOption = Array.from(checkedInputs, (input) => input.value);
      const currentVariant = parsedVariantsJSON.find((variant) => variant.options.join(",") === checkedOption.join(","));
      if (currentVariant) {
        this.updateDateDelivery(currentVariant.metafields && currentVariant.metafields.active ? currentVariant.metafields : null);
        this.updateATCPreorder(currentVariant.metafields && currentVariant.metafields.active ? true : false);
      }
    }
  }

  // Update legends in the parsed data
  updateLegends(checkedInputs, parsedData) {
    checkedInputs.forEach((input, index) => {
      const l = parsedData.querySelectorAll("legend").length;
      parsedData.querySelectorAll("legend")[index].querySelector(".js-current-option").textContent = input.value;
      const stickyVariantsLegend = parsedData.querySelectorAll("legend")[index + l / 2];
      if (stickyVariantsLegend) {
        parsedData.querySelectorAll("legend")[index + l / 2].querySelector(".js-current-option").textContent = input.value;
      }
    });
  }

  cleanup() {
    document.removeEventListener("variantDataChanged", this.handleVariantDataChanged);
  }
}

customElements.define("variant-picker", VariantChange);

function checkCurrentQueryVariant() {
  const url = new URL(window.location.href);
  if (url.searchParams.has("variant")) {
    const checkedInput = document.querySelector("variant-picker .js-variants-update:checked");
    checkedInput == null ? void 0 : checkedInput.click();
  }
}

checkCurrentQueryVariant();

function clickOnCheckedOption() {
  const isSubscriptionProduct = document.querySelector('input[name="subscription"]');
  if (isSubscriptionProduct) {
    document.querySelectorAll('input[name="subscription"]:checked').forEach((el) => {
      let labelDiv = el.nextElementSibling;
      labelDiv.querySelector("label").click();
    });
  } else {
    const quantityInput = document.querySelector("jolly-quantity-selector input");
    const quantity = (quantityInput == null ? void 0 : quantityInput.value) || 1;
    const priceBlocks = document.querySelectorAll(".js-price-block");
    priceBlocks.forEach((addToCartBtn) => {
      const startingPrice = addToCartBtn.dataset.originalPrice;
      const originalPriceButton = addToCartBtn.querySelector(".jc-current-price");

      if(!document.querySelector('deployer-quantity-breaks')){
        originalPriceButton.innerHTML = `${currentCurrency}${((parseFloat(startingPrice.replace(/\D/g, "")) / 100) * quantity).toFixed(2).replace(".", ",")}`;
      }
    });
  }
}

window.addEventListener("load", function () {
  const labelsWrapper = document.querySelector(".js-labels-wrapper");
  function insertPlanOptions() {
    if (labelsWrapper == null) return;

    waitForElm(".rc_widget__option__plans__dropdown option").then(() => {
      const optionPlansDropdownOptions = document.querySelectorAll(".rc_widget__option__plans__dropdown option");
      optionPlansDropdownOptions.forEach((el, i) => {
        labelsWrapper.insertAdjacentHTML(
          "beforeend",
          `
          <input
            class="jc-planOption-input jc-w-0 jc-h-0 jc-absolute jc-overflow-hidden jc-invisible"
            type="radio"
            id="${el.dataset.planOption.trim()}"
            name="planOpiton-input"
            value="${el.value}"
            ${i === 0 ? "checked" : null}
          >
          <label
            class="jc-cursor-pointer jc-relative jc-planOption-label"
            for="${el.dataset.planOption.trim()}"
          >
            <span class="jc-planOption-input-inner jc-inline-block jc-overflow-hidden jc-font-[Archivo-Semibold] jc-text-xs jc-leading-3.5 md:jc-text-sm md:jc-leading-3 jc-transition-all jc-duration-200 jc-ease-[ease] jc-rounded-xs">
              <span class="jc-planOption-input-inner-span js-planOption-inner jc-flex jc-items-center jc-px-3 jc-py-1.5">
                ${listOfRechargeLabels ? listOfRechargeLabels[i].trim() : el.dataset.planOption.trim()}
              </span>
            </span>
          </label>
        `
        );
      });
    });
  }

  function waitForElm(selector) {
    return new Promise((resolve) => {
      if (document.querySelector(selector)) {
        return resolve(document.querySelector(selector));
      }
      const observer = new MutationObserver((mutations) => {
        if (document.querySelector(selector)) {
          observer.disconnect();
          resolve(document.querySelector(selector));
        }
      });
      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });
    });
  }

  function handleJcSaleMethodRadioClick(saleMethodRadio) {
    const isSubscription = saleMethodRadio.classList.contains("jc-subscription-input");
    const labelToClick = isSubscription ? document.querySelector("[data-option-subsave]") : document.querySelector("[data-option-onetime]");
    labelToClick.click();
    setOptionName(isSubscription);
    updatePriceBuyButton(saleMethodRadio);
  }

  function setOptionName(isSubscription) {
    const targetText = isSubscription ? document.querySelector(".js-subscription-text") : document.querySelector(".js-onetime-text");
    const stickyOptionText = document.querySelector(".js-sticky-option-text");
    const stickyInfo = document.querySelector(".jolly-sticky-atc--subscription_infos");
    stickyInfo.classList.remove("jc-hidden");
    document.querySelector(".js-subscription-text").style.display = isSubscription ? "inline-block" : "none";
    document.querySelector(".js-onetime-text").style.display = isSubscription ? "none" : "inline-block";
    stickyOptionText.innerHTML = targetText.innerHTML;
  }

  function handlePlanOptionInputClick(input) {
    const optionPlansDropdown = document.querySelector(".rc_widget__option__plans__dropdown");
    const stickyCurrentPlan = document.querySelector(".js-sticky-current-subs-plan");
    optionPlansDropdown.value = input.value;
    stickyCurrentPlan.innerHTML = input.nextElementSibling.querySelector(".js-planOption-inner").innerHTML;
  }

  const mutationCallback = (mutationList, observer2) => {
    for (const mutation of mutationList) {
      if (mutation.type === "childList") {
        insertPlanOptions();
        handlePricesAndDiscounts();
        observer2.disconnect();
        break;
      }
    }

    waitForElm('input[name="planOpiton-input"]').then(() => {
      const planOptionInputs = document.querySelectorAll('input[name="planOpiton-input"]');
      planOptionInputs.forEach((el) => {
        el.addEventListener("click", () => handlePlanOptionInputClick(el));
      });
      planOptionInputs[0].click();
    });

    if (document.querySelector("[data-option-subsave]") !== null) {
      document.querySelectorAll(".jc-sale-method-radio").forEach((el) => {
        el.addEventListener("click", () => handleJcSaleMethodRadioClick(el));
      });
    }
    subscriptionLoaded();
  };
  const observer = new MutationObserver(mutationCallback);
  const targetNode = document.querySelector(".rc-widget-injection-parent");
  const listOfRechargeLabels = JSON.parse(document.querySelector("[data-recharge-labels-json]").textContent);
  const config = { attributes: true, childList: true, subtree: true };
  observer.observe(targetNode, config);
});

function handlePricesAndDiscounts() {
  const rechargeSubscriptionPrice = document.querySelector("[data-subscription-price]").dataset.subscriptionPrice;
  const rechargeOnetimePrice = document.querySelector("[data-price-onetime]");
  const comparePriceBlock = document.querySelector("[data-with-compare-price]");
  const onetimePriceBlock = document.querySelector("[data-without-compare-price]");
  const rechargeDiscount = document.querySelector("[data-label-discount]");
  const productOriginalPrice = document.querySelector("#buy-button-block").dataset.originalPrice;
  const firstCustomLabel = document.querySelector(".jc-subscription-input");

  if (!rechargeDiscount) {
    return;
  }

  const productHasSubscriptionDiscount = rechargeDiscount.innerHTML.trim() !== "";

  setTimeout(() => {
    if (productHasSubscriptionDiscount) {
      comparePriceBlock && (comparePriceBlock.style.display = "flex");
      firstCustomLabel && (firstCustomLabel.style.alignItems = "flex-start");

      const compareAtPriceBlock = document.querySelectorAll(".js-recharge-discount");
      if (compareAtPriceBlock && rechargeDiscount) {
        compareAtPriceBlock.forEach((el) => {
          el.innerHTML = rechargeDiscount.innerHTML;
        });
        comparePriceBlock.querySelector(".js-onetime-price").textContent = productOriginalPrice;
        comparePriceBlock.querySelector(".js-subscripiton-price").textContent = rechargeSubscriptionPrice;
      }
    } else {
      onetimePriceBlock.style.display = "flex";
      firstCustomLabel.style.alignItems = "center";
      firstCustomLabel.style.paddingBottom = "16px";
      if (rechargeOnetimePrice) {
        onetimePriceBlock.querySelector(".js-onetime-price").textContent = productOriginalPrice;
      }
    }
    clickOnCheckedOption();
  }, 0);
}

function getSelectedQuantity() {
  const quantityInput = document.querySelector("jolly-quantity-selector input");
  return (quantityInput == null ? void 0 : quantityInput.value) || 1;
}

function formatPrice(priceString, quantity) {
  const numericValue = parseFloat(priceString.replace(/\D/g, ""));
  const formattedValue = ((numericValue / 100) * quantity).toFixed(2).replace(".", ",");
  return `${currentCurrency}` + formattedValue;
}

function updateAllPricesWithoutDiscount(quantity) {
  const priceBlocks = document.querySelectorAll(".js-price-block");
  priceBlocks.forEach((block) => {
    let startingPrice = block.dataset.originalPrice;
    let originalPriceButton = block.querySelector(".jc-current-price");

    if(!document.querySelector('deployer-quantity-breaks')){
      originalPriceButton.innerHTML = formatPrice(startingPrice, quantity);
    }
  });
}

function hideCompareAtPrice(buttonCompareAtPrice, buttonOriginalPrice) {
  buttonCompareAtPrice.classList.add("jc-hidden");
  buttonOriginalPrice.classList.remove("jc-price-highlight");
  buttonCompareAtPrice.innerHTML = "";
}

function updateButtonsCompareAtPrice(oneTimePriceElement, updatedPriceElement, quantity) {
  const buttonsCompareAtPrice = document.querySelectorAll(".js-recharge_compare");
  buttonsCompareAtPrice.forEach((buttonCompareAtPrice) => {
    const buttonOriginalPrice = buttonCompareAtPrice.nextElementSibling;
    if (oneTimePriceElement) {
      buttonCompareAtPrice.classList.remove("jc-hidden");
      buttonOriginalPrice.classList.add("jc-price-highlight");
      if (oneTimePriceElement.innerHTML != "" && oneTimePriceElement.style.display != "none") {
        buttonCompareAtPrice.innerHTML = formatPrice(oneTimePriceElement.innerHTML, quantity);
      } else {
        buttonCompareAtPrice.innerHTML = "";
      }
    } else {
      hideCompareAtPrice(buttonCompareAtPrice, buttonOriginalPrice);
    }
    buttonOriginalPrice.innerHTML = formatPrice(updatedPriceElement.innerHTML, quantity);
  });
}

function updatePriceBuyButton(saleMethodRadio) {
  const rechargeDiscount = document.querySelector("[data-label-discount]");
  const productHasSubscriptionDiscount = rechargeDiscount.innerHTML.trim() !== "";
  const quantity = getSelectedQuantity();
  const saleMethodOneTimePrice = saleMethodRadio.querySelector(".js-onetime-price");
  const saleMethodUpdatedPrice = saleMethodRadio.querySelector(".js-update-price");
  if (!productHasSubscriptionDiscount) {
    updateAllPricesWithoutDiscount(quantity);
    return;
  }
  /*if(document.querySelector('upsell-variant-picker') != null){
    updateButtonsCompareAtPrice(saleMethodOneTimePrice, saleMethodUpdatedPrice, 1);
  } else {
  }*/
  updateButtonsCompareAtPrice(saleMethodOneTimePrice, saleMethodUpdatedPrice, quantity);
}


function updateCarousel(options, currentVariantImageId = null) {
  let currentSlides = [];
  let currentThumbs = [];
  let currentMobileThumbs = [];

  for (var i = 0; i < slides.length; i++) {
    const currentSlide = slides[i];
    const currentAlt = currentSlide.dataset.slideAlt;
    const splitOptions = options.flatMap((option) => option.split("-"));
    const altArray = currentAlt.replace("filter_", "").split("-").filter(Boolean);
    const sortedOptions = splitOptions.sort().join("");
    const sortedAlt = altArray.sort().join("");

    if (!currentAlt.includes("filter_") || currentAlt.includes("filter_") && sortedOptions === sortedAlt) currentSlides.push(currentSlide);
  }

  for (var i = 0; i < thumbs.length; i++) {
    const currentThumb = thumbs[i];
    const currentMobileThumb = thumbsMobile[i];
    const currentAlt = currentThumb.dataset.slideAlt;
    const currentMobileAlt = currentThumb.dataset.slideAlt;
    const splitOptions = options.flatMap((option) => option.split("-"));
    const altArray = currentAlt.replace("filter_", "").split("-").filter(Boolean);
    const sortedOptions = splitOptions.sort().join("");
    const sortedAlt = altArray.sort().join("");

    if (!currentAlt.includes("filter_") || currentAlt.includes("filter_") && sortedOptions === sortedAlt) currentThumbs.push(currentThumb);
    if (!currentMobileAlt.includes("filter_") || currentMobileAlt.includes("filter_") && sortedOptions === sortedAlt) currentMobileThumbs.push(currentMobileThumb);
  }

  // Si des slides et des miniatures correspondantes sont trouvées
  if (currentThumbs.length > 0 && currentSlides.length > 0) {

    productMainSliderThumbNails.removeAllSlides();
    productMainSliderThumbNailsMobile.removeAllSlides();
    productMainSlider.removeAllSlides();

    // Ajouter les slides au slider
    productMainSliderThumbNails.addSlide(1, currentThumbs);
    productMainSliderThumbNailsMobile.addSlide(1, currentMobileThumbs);
    productMainSlider.addSlide(1, currentSlides);

    // Ajuster la vue des miniatures
    const adjustedSlidesPerView = Math.min(thumbCount, currentThumbs.length);
    productMainSliderThumbNails.params.slidesPerView = adjustedSlidesPerView;
    const thumbsWrapper = thumbsSwiper.querySelector(".swiper-wrapper");

    if (adjustedSlidesPerView == 3) thumbsWrapper.classList = "swiper-wrapper jc-max-h-[152px] xl:jc-max-h-[224px]";
    else if (adjustedSlidesPerView == 2) thumbsWrapper.classList = "swiper-wrapper jc-max-h-[96px] xl:jc-max-h-[144px]";
    else thumbsWrapper.classList = "swiper-wrapper jc-max-h-[40px] xl:jc-max-h-[64px]";

    productMainSliderThumbNails.update();
    productMainSliderThumbNailsMobile.update();
    productMainSlider.update();

    if (!currentVariantImageId) {
      productMainSlider.slideTo(0, 0, false);
      productMainSliderThumbNails.slideTo(0, 0, false);
      productMainSliderThumbNailsMobile.slideTo(0, 0, false);
    }
    productMainSlider.slideTo(0, 0, false);
  }

  if (currentVariantImageId) {
    const mainSlides = productMainSlider.slides;
    const thumbSlides = productMainSliderThumbNails.slides;
    const mobileThumbSlides = productMainSliderThumbNailsMobile.slides;

    const mainSlideIndex = Array.from(mainSlides).findIndex(
      (slide) => slide.dataset.productImageId == currentVariantImageId
    );
    const thumbSlideIndex = Array.from(thumbSlides).findIndex(
      (thumb) => thumb.dataset.productImageId == currentVariantImageId
    );
    const mobileThumbSlideIndex = Array.from(mobileThumbSlides).findIndex(
      (thumb) => thumb.dataset.productImageId == currentVariantImageId
    );

    if (mainSlideIndex !== -1) productMainSlider.slideTo(mainSlideIndex, 0, false);
    if (thumbSlideIndex !== -1) productMainSliderThumbNails.slideTo(thumbSlideIndex, 0, false);
    if (mobileThumbSlideIndex !== -1) productMainSliderThumbNailsMobile.slideTo(mobileThumbSlideIndex, 0, false);

    document.querySelectorAll("[data-sticky-product-image-id]").forEach((image) => {
      image.classList.remove("jc-opacity-100");
      image.classList.add("jc-opacity-0");
    });

    const stickyImage = document.querySelector(`[data-sticky-product-image-id="${currentVariantImageId}"]`);
    if (stickyImage) stickyImage.classList.add("jc-opacity-100");
  }
}

function centerActiveThumb(slider, thumbsSlider) {
  const activeIndex = slider.realIndex;
  thumbsSlider.slideTo(activeIndex);
}

productMainSlider.on('slideChange', function () {
  centerActiveThumb(productMainSlider, productMainSliderThumbNailsMobile);
});